<!-- 加载动画 -->
<template>
	<div class="loading flex_g vertical flex_center flex_column"  v-show="loading">
    <img src="@/assets/images/load.gif">
    <p>加载中.....</p>
  </div>
</template>

<script>
export default {
  name: 'loading',
  data(){
    return{
        loading:true,
    }
  },
  methods:{
    open(){
        this.loading = true;
    },
  	close(type){
      let that =this
      //that.loading = false;
      setTimeout(function(){
         that.loading = false;
      },1)
       
    }
  }
}
</script>

<style lang="scss" scoped>
.loading{
    width:100%;
    height:100%;
    position: fixed;
    bottom:0;
    left:0;
    overflow: hidden;
    z-index: 10000;
    background:#fff;
    opacity: 1;
    img{
        width:300px ;
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
    }
    p{
    transform: translateY(50px);
    color:#999;
    font-size: 1.1rem;
    }
}

</style>